// extracted by mini-css-extract-plugin
export default {"content":"Upload_content__dLY2A","subtitle":"Upload_subtitle__X1Lf1","title":"Upload_title__Pu2OG","bd_callout":"Upload_bd_callout__w6KvB"};